<template>
   <div class="container-fluid">

     <div class="title-container">
       <h3 class="title">
         Backlog
         <div
           class="spinner-border spinner-theme_default"
           role="status"
           v-if="isDataPageLoading"
         >
                <span class="sr-only">
                  Loading...
                </span>
         </div>
       </h3>
       <div class="title-container__controls">
         <b-button
           class="button title-container__controls-item"
           :variant="isShowFilter ? 'secondary' : 'info'"
           @click="toggleShowFilter"
         >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
           Filters
         </b-button>
       </div>
     </div>

     <Filters
       v-show="isShowFilter"
       textButtonSubmit="Get Report"
       :data="filters"
       :isLoading="isDataPageLoading"
       @submit="getNotBudget"
     />

     <TableForPage
       ref="refs"
       class="not-estimated-table"
       v-if="table.data.length"
       :slots="table.slots"
       :tableData="table.data"
       :fields="table.fields"
     >
       <template v-slot:projectName="data">
         <a :href="'https://giraffesoftware.atlassian.net/browse/' + data.item.key" target="_blank">
           <img
             class="project-icon"
             :src="data.item.projectIcons['48x48']"
             :alt="data.item.project_name"
           >
           {{data.item.projectName}}
         </a>
       </template>
       <template v-slot:key="data">
         <a :href="'https://giraffesoftware.atlassian.net/browse/' + data.item.key" target="_blank">
           {{ data.item.key }}
         </a>
       </template>
       <template v-slot:remainingEstimate="data">
         {{ data.item.remainingEstimate.hours }} hrs ({{ data.item.remainingEstimate.days }} days)
       </template>
       <template v-slot:budget="data">
         {{ data.item.budget.hours }} hrs ({{ data.item.budget.days }} days)
       </template>

       <template v-slot:row="slotProps">
         <NestedTable
           style="margin-bottom: 0;"
           :items="Object.values(slotProps.row.item.issues)"
           :fields="nestedTable.fields"
           :slots="nestedTable.slots"
         >
           <template v-slot:key="data">
             <a :href="'https://giraffesoftware.atlassian.net/browse/' + data.item.key" target="_blank">
               {{ data.item.key }}
             </a>
           </template>
           <template v-slot:remainingEstimate="data">
             {{ data.item.remainingEstimate.hours }} hrs ({{ data.item.remainingEstimate.days }} days)
           </template>
           <template v-slot:budget="data">
             {{ data.item.budget.hours }} hrs ({{ data.item.budget.days }} days)
           </template>
           <template v-slot:labels="data">
             {{ data.item.labels.join(',') }}
           </template>
           <template v-slot:updatedDate="data">
             {{ _toLocalTime(data.item.updatedDate) }}
           </template>
         </NestedTable>
       </template>

     </TableForPage>
  </div>
</template>

<script>
import Filters from '@components/Filter/Filter'
import TableForPage from '@tables/TableForPage'
import { mapGetters } from 'vuex'
import NestedTable from '@tables/NestedTable'

export default {
  name: 'MiscBacklog',
  components: {
    TableForPage,
    NestedTable,
    Filters
  },
  data () {
    return {
      isShowFilter: true,
      filters: {
        'date_from': {
          type: 'datepicker',
          name: 'date_from',
          label: 'Date from',
          format: 'dd/MM/yyyy',
          value: null,
          class: 'col-md-3'
        },
        'date_to': {
          type: 'datepicker',
          name: 'date_to',
          label: 'Date to',
          format: 'dd/MM/yyyy',
          value: null,
          class: 'col-md-3'
        },
        'projects': {
          type: 'select',
          name: 'project',
          label: 'Projects',
          selectLabel: 'name',
          valueField: 'key',
          options: [],
          class: 'col-md-3'
        },
        'assignee': {
          type: 'select',
          name: 'assignee',
          label: 'Assignee',
          selectLabel: 'name',
          valueField: 'name',
          options: [],
          class: 'col-md-3'
        },
        'project_manager': {
          type: 'select',
          name: 'project_manager',
          label: 'Project manager',
          selectLabel: 'name',
          valueField: 'id',
          options: [],
          class: 'col-md-3'
        },
        'issue_status': {
          type: 'select',
          name: 'status',
          label: 'Status',
          options: [],
          class: 'col-md-3'
        },
        'labels': {
          type: 'select',
          name: 'label',
          label: 'Labels',
          options: [],
          class: 'col-md-3'
        }
      },
      table: {
        slots: {
          projectName: {
            name: 'projectName'
          },
          key: {
            name: 'key'
          },
          remainingEstimate: {
            name: 'remainingEstimate'
          },
          budget: {
            name: 'budget'
          }
        },
        fields: [
          {
            key: 'projectName',
            label: 'Project',
            sortable: true
          },
          {
            key: 'key',
            label: 'Issue',
            sortable: true
          },
          {
            key: 'remainingEstimate',
            label: 'Remaining time Hrs (days)'
          },
          {
            key: 'budget',
            label: 'Budget Hrs (days)'
          },
          {
            key: 'more',
            label: 'More',
            class: 'column-more'
          }

        ],
        data: []
      },
      nestedTable: {
        fields: [
          {
            key: 'key',
            label: 'Issue',
            sortable: true
          },
          {
            key: 'type',
            label: 'Issue Type',
            sortable: true
          },
          {
            key: 'status',
            label: 'Issue Status',
            sortable: true
          },
          {
            key: 'remainingEstimate',
            label: 'Remaining time Hrs (days)'
          },
          {
            key: 'budget',
            label: 'Budget Hrs (days)'
          },
          {
            key: 'assigneeUserDisplayName',
            label: 'Assignee'
          },
          {
            key: 'projectManagerName',
            label: 'Project manager'
          },
          {
            key: 'labels',
            label: 'Labels'
          },
          {
            key: 'updatedDate',
            label: 'Date Updated'
          }
        ],
        slots: {
          key: {
            name: 'key'
          },
          remainingEstimate: {
            name: 'remainingEstimate'
          },
          budget: {
            name: 'budget'
          },
          labels: {
            name: 'labels'
          },
          updatedDate: {
            name: 'updatedDate'
          }
        }
      },

      isDataPageLoading: false
    }
  },
  computed: {
    ...mapGetters({
      getAllUsers: 'getAllUsers',
      getProjects: 'projects/getProjects',
      getProjectManagers: 'users/getProjectManagers',
      getIssueStatuses: 'getIssueStatuses',
      getLabelsList: 'issue/getLabelsList'
    }),
    notBudgetTasks () {
      return this.$store.getters.getNotBudgetIssues || []
    }
  },
  created () {
    this.fetchAllData()
  },
  methods: {
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    resetPagination () {
      this.$refs['table'] && this.$refs['table'].resetPagination()
    },
    getNotBudget (fields) {
      const data = this.prepareDataForGetNotBudget(fields)

      this._toggleDataPageLoading(async () => {
        const result = await this.$api.issues.getIssueNotDoneAndEstimated(data)
        console.log('result', result)
        this.table.data = this.convertObjectToArray(result)

        this.resetPagination()
      })
    },
    convertObjectToArray (data) {
      let result = []

      for (let key in data) {
        result.push({ 'key': key, ...data[key] })
      }

      return result
    },
    prepareDataForGetNotBudget (fields) {
      let newFields = fields
      let data = {}

      newFields.date_from.value = this._toLocalTime(newFields.date_from.value)
      newFields.date_to.value = this._toLocalTime(newFields.date_to.value)

      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']

        if (fields[key].valueField !== undefined && value) {
          value = value[fields[key].valueField]
        }
        data[name] = value
      }

      return data
    },
    fetchAllData () {
      Promise.all([
        this.fetchAllUsers(),
        this.fetchAllProjects(),
        this.fetchProjectManagers(),
        this.fetchIssueStatuses(),
        this.fetchIssueLabels()
      ])
        .then(() => {
          this.setAllOptionsFilter()
        })
    },
    async fetchAllProjects () {
      if (this.getProjects.length) return

      await this.$api.projects.getProjects()
    },
    async fetchIssueLabels () {
      await this.$api.issues.getIssueLabels()
    },
    async fetchProjectManagers () {
      if (this.getProjectManagers.length) return

      await this.$api.users.getProjectManagers()
    },
    async fetchAllUsers () {
      if (this.getAllUsers.length) return

      return this.$api.users.getAllUsers()
    },
    async fetchIssueTypes () {
      if (this.getIssueTypes.length) return

      return this.$api.issues.getIssueTypes()
    },
    async fetchIssueStatuses () {
      if (this.getIssueStatuses.length) return

      return this.$api.issues.getIssueStatuses()
    },

    setAllOptionsFilter () {
      this.filters.projects.options = this.getProjects
      this.filters.issue_status.options = Object.values(this.getIssueStatuses)
      this.filters.assignee.options = this.getAllUsers
      this.filters.project_manager.options = this.getProjectManagers
      this.filters.labels.options = this.getLabelsList
    }
  }
}
</script>

<style lang="scss" >
.not-estimated-page {
    .spinner-border {
        position: relative;
        top: 0;
    }
}

.not-estimated-table {

  .issue-icon {
    position: relative;
    top: -2px;
    margin-right: 3px;
  }

  .project-icon {
    position: relative;
    max-width: 20px;
    top: -2px;
    margin-right: 5px;
  }
}

</style>
